import axios from '../config/http'
import qs from 'qs'
import { baseUrl } from '../config/env'

/**
 ************************** 登录 ****************************
 */
/** 账号密码登录 **/
export const loginByPassword = (data) => {
  let url = baseUrl + '/login/login'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 验证码登录 **/
export const loginByCode = (data) => {
  let url = baseUrl + '/login/login_m'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取验证码 **/
export const getLoginCode = (data) => {
  let url = baseUrl + '/login/getcode_l'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 ************************** 退出登录****************************
 */
export const logout = () => {
  let url = baseUrl + '/login/logout'
  let response = axios.get(url)
  return response
}

/**
 ************************** 注册 ****************************
 */
export const register = (data) => {
  let url = baseUrl + '/member/register'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 ************************** 忘记密码 ****************************
 */
/** 获取验证码 **/
export const getForgetCode = (data) => {
  let url = baseUrl + '/member/getcode_f'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 找回密码第一步 **/
export const getForgetStepOne = (data) => {
  let url = baseUrl + '/member/forget'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 找回密码第二步 **/
export const getForgetStepTwo = (data) => {
  let url = baseUrl + '/member/forget_next'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}
